module.exports = __webpack_public_path__ + "img/borna-identity.62faa575.png";